import { FDPrimaryActionButton } from '@facet-wealth/design';
import { clientPaths } from 'Consts/Strings';
import { encodeQuery } from 'Helpers/Query';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { dataAttrs } from 'Helpers/Testing';

export const TakeMeToAllActionsButton = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    const params = {
      modal: 'actionItemList',
    };
    history.push({
      pathname: clientPaths.dashboard,
      search: encodeQuery(params),
    });
    // We don't set loading back to false because this component gets destroyed when we navigate away
  };

  return (
    <FDPrimaryActionButton
      onClick={handleClick}
      label={'Take me to all my actions'}
      loading={loading}
      flex={1}
      isFullWidth
      {...dataAttrs('all-actions-button')}
    />
  );
};
